import axios from 'axios';

// Use environment variable or fallback to local IP
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://webcms-app.sj.co.tz/api/';

console.log('🔧 API Base URL:', API_BASE_URL);

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'ApiAuth': 'Basic'
  },
  timeout: 15000, // 15 second timeout
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const siteId = localStorage.getItem('SID') || 'ef22f550-854a-4f99-b537-9ed87fa77062';
    
    console.log('🚀 Making API Request:', {
      url: config.url,
      method: config.method,
      siteId: siteId
    });

    if (siteId) {
      config.headers['SID'] = siteId;
    }

    return config;
  },
  (error) => {
    console.error('❌ Request Interceptor Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('✅ API Response Success:', {
      url: response.config.url,
      status: response.status,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('❌ API Response Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
      data: error.response?.data
    });
    
    // Enhanced error handling
    if (error.code === 'ECONNREFUSED') {
      error.message = `Cannot connect to server at ${API_BASE_URL}. Make sure the server is running.`;
    } else if (error.code === 'NETWORK_ERROR') {
      error.message = 'Network error. Please check your internet connection.';
    } else if (error.response?.status === 404) {
      error.message = `API endpoint not found: ${error.config.url}`;
    } else if (error.response?.status === 401) {
      error.message = 'Authentication failed. Check your API credentials.';
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;